"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _taggedTemplateLiteral2 = require("babel-runtime/helpers/taggedTemplateLiteral");

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2; /**
                     * Copyright 2013-present, Novivia, Inc.
                     * All rights reserved.
                     */

var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n              ", "\n              ", "\n              ", "\n            "], ["\n              ", "\n              ", "\n              ", "\n            "]);

var _configurations = require("@auex/configurations");

var _FeedbackAlert = require("./FeedbackAlert");

var _FeedbackAlert2 = _interopRequireDefault(_FeedbackAlert);

var _TimeDifference = require("./TimeDifference");

var _TimeDifference2 = _interopRequireDefault(_TimeDifference);

var _utilities = require("@auex/utilities");

var _utilities2 = _interopRequireDefault(_utilities);

var _Button = require("react-bootstrap/Button");

var _Button2 = _interopRequireDefault(_Button);

var _ButtonGroup = require("react-bootstrap/ButtonGroup");

var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);

var _Col = require("react-bootstrap/Col");

var _Col2 = _interopRequireDefault(_Col);

var _Form = require("react-bootstrap/Form");

var _Form2 = _interopRequireDefault(_Form);

var _HelpBlock = require("react-bootstrap/HelpBlock");

var _HelpBlock2 = _interopRequireDefault(_HelpBlock);

var _Panel = require("react-bootstrap/Panel");

var _Panel2 = _interopRequireDefault(_Panel);

var _Row = require("react-bootstrap/Row");

var _Row2 = _interopRequireDefault(_Row);

var _Table = require("react-bootstrap/Table");

var _Table2 = _interopRequireDefault(_Table);

var _colorHash = require("color-hash");

var _colorHash2 = _interopRequireDefault(_colorHash);

var _currency = require("currency");

var _datetime = require("datetime");

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _tempura = require("tempura");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Combobox = require("react-widgets/lib/Combobox");

var _Combobox2 = _interopRequireDefault(_Combobox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var computeAskingPrice = _utilities2.default.logic.bidding.computeAskingPrice;


var colorHash = new _colorHash2.default();

/**
 * Absentee bid module.
 * @class
 */
var AbsenteeBidModule = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(AbsenteeBidModule, _Component);

  function AbsenteeBidModule() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AbsenteeBidModule);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AbsenteeBidModule.__proto__ || (0, _getPrototypeOf2.default)(AbsenteeBidModule)).call.apply(_ref, [this].concat(args))), _this), _this.generateBidSuggestions = function () {
      var bidAmount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var bidSuggestions = [];

      var currentAmount = Math.max(Number(bidAmount), _this.props.lot.leadingBid && _this.props.lot.leadingBid.amount || 0, _this.props.user.maximumBid + 0.001 || 0, _this.props.user.lastBid + 0.001 || 0);
      var delta = _this.props.lot.leadingBid && _this.props.lot.leadingBid.amount === currentAmount ? 0 : 0.001;
      currentAmount = currentAmount ? currentAmount - delta : 0;

      // FIXME: Fix the autocomplete here to allow custom values.
      for (var i = 0; i < 1000; i++) {
        currentAmount = computeAskingPrice(currentAmount, _this.props.auction.increments);

        bidSuggestions.push({
          text: (0, _currency.formatMoney)(currentAmount, _this.props.auction.currency.iso.code),
          value: currentAmount
        });
      }

      return bidSuggestions;
    }, _this.state = {
      // Amount of the bid.
      bidAmount: null,

      // Current number of bids.
      bidCount: _this.props.lot.bids.length,

      // Alert states.
      bidErrors: null,
      bidSuccess: null,

      bidSuggestions: _this.generateBidSuggestions(),

      // Current user has the leading bid.
      hasLeadingBid: _this.props.lot.leadingBid && _this.props.lot.leadingBid.byCurrentUser,

      // Login modal
      isLoginModalOpen: false,

      // Are we bidding a maximum? Depends on the bidMode.
      isMaximumBidding: _this.props.auction.bidMode === _configurations.AE_AUCTION_BID_MODE.STANDARD,

      // Currently leading bid amount.
      leadingBid: _this.props.lot.leadingBid && _this.props.lot.leadingBid.amount,

      // Relative time difference in seconds.
      timeUntilStart: (0, _moment2.default)(_this.props.auction.bidEndDate).diff(),

      // User maximum bid
      userMaximumBid: _this.props.user.maximumBid
    }, _this.handleInputChange = function (e) {
      var nextState = {};
      nextState[e.target.name] = e.target.value;
      _this.setState(nextState);
    }, _this.handleMakeBid = function (e) {
      e.preventDefault();

      var __ = _this.context.__;


      if (!_this.state.bidAmount) {
        return _this.setState({
          bidErrors: __("errors::bid.invalidAmount"),
          bidSuccess: null
        });
      }

      // Either this is a standard bid or a maximum bid.
      var makeBid = _this.state.isMaximumBidding ? _this.props.actions.lot.makeMaximumBid : _this.props.actions.lot.makeStandardBid;

      makeBid({
        auctionId: _this.props.auction.id,
        bidAmount: _this.state.bidAmount,
        lotId: _this.props.lot.id
      }, function (err) {
        return _this.setState({
          bidErrors: err || null,
          bidSuccess: !err
        });
      });
    }, _this.handleToggleMaximumBid = function () {
      // We can only submit higher maximum bids when we lead.
      if (_this.state.hasLeadingBid) {
        return;
      }

      _this.setState(function (state) {
        return { isMaximumBidding: !state.isMaximumBidding };
      });
    }, _this.nextBid = function (amount) {
      var incrementLevels = _this.props.auction.increments;
      var incrementLevel = incrementLevels[0];

      for (var i = 0; i < incrementLevels.length; i++) {
        if ((i < incrementLevels.length - 1 ? incrementLevels[i + 1].start > amount : true) && incrementLevels[i].start <= amount) {
          incrementLevel = incrementLevels[i];
        }
      }

      return amount + incrementLevel.jump;
    }, _this.tick = function () {
      _this.setState({
        timeUntilStart: (0, _moment2.default)(_this.props.auction.bidEndDate).diff()
      });
    }, _this.handleBidAmountChange = function (update) {
      var bidAmount = Number(typeof update === "string" ? update : update.value) || 0;

      var bidSuggestions = _this.generateBidSuggestions(bidAmount);

      _this.setState({
        bidAmount: bidAmount || "",
        bidSuggestions: bidSuggestions
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AbsenteeBidModule, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Show time left with hourly updates unless we're in the last hour.
      var interval = 60 * 60 * 1000;
      this.interval = setInterval(this.tick, new Date() - new Date(this.props.auction.bidEndDate) < interval ? 1000 : interval);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }

    /**
     * Change the type of bidding (normal bid vs maximum bid)
     */


    /**
     * Find the next bid with increments for a given amount.
     */


    /**
     * Relative time with the auction.
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var __ = this.context.__;

      // If bidding is disabled, we simply don't display the bidding component.

      if (this.props.auction.bidMode === _configurations.AE_AUCTION_BID_MODE.NONE) {
        return null;
      }

      // The informantion on the bid if we are in standard bid mode.
      var bidMode = null;
      var bidInformation = null;

      if (this.props.auction.bidMode === _configurations.AE_AUCTION_BID_MODE.STANDARD) {
        bidMode = _react2.default.createElement(
          "span",
          null,
          "(",
          __("auction::bidMode.standard"),
          ")"
        );
        bidInformation = _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _Col2.default,
            { md: 4 },
            _react2.default.createElement(
              "strong",
              null,
              this.state.bidCount > 0 ? __("auction::lot.leadingBid") : __("auction::lot.startingBid")
            )
          ),
          _react2.default.createElement(
            _Col2.default,
            { md: 8 },
            _react2.default.createElement(
              "p",
              null,
              (0, _currency.formatMoney)(this.state.bidCount > 0 ? this.state.leadingBid : this.props.lot.startingBid, this.props.auction.currency.iso.code),
              " ",
              _react2.default.createElement(
                "strong",
                null,
                "(",
                this.state.bidCount,
                " ",
                __("auction::lot.bids"),
                ")"
              )
            )
          )
        );
      } else if (this.props.auction.bidMode === _configurations.AE_AUCTION_BID_MODE.SILENT) {
        bidMode = _react2.default.createElement(
          "span",
          null,
          "(",
          __("auction::bidMode.silent"),
          ")"
        );
      }

      var bidding = null;
      if (this.props.auction.status === _configurations.AE_AUCTION_STATUS.UNPUBLISHED || this.props.auction.status === _configurations.AE_AUCTION_STATUS.PUBLISHED) {
        bidding = _react2.default.createElement(_FeedbackAlert2.default, {
          info: __("auction::lot.biddingNotStarted", {
            startTime: (0, _datetime.localizeDate)({
              date: this.props.auction.bidStartDate
            }).date
          }),
          permanent: true
        });
      } else if (this.props.auction.status === _configurations.AE_AUCTION_STATUS.BIDDING_OVER) {
        bidding = _react2.default.createElement(_FeedbackAlert2.default, {
          info: __("auction::lot.biddingOver"),
          permanent: true
        });
      } else if (this.props.auction.status === _configurations.AE_AUCTION_STATUS.ONGOING) {
        bidding = _react2.default.createElement(_FeedbackAlert2.default, {
          info: __("auction::ongoing"),
          permanent: true
        });
      } else if (this.props.auction.status === _configurations.AE_AUCTION_STATUS.FINISHED) {
        bidding = _react2.default.createElement(_FeedbackAlert2.default, {
          info: __("auction::over"),
          permanent: true
        });
      } else if (this.props.auction.status === _configurations.AE_AUCTION_STATUS.CANCELLED) {
        bidding = _react2.default.createElement(_FeedbackAlert2.default, {
          warning: __("auction::cancelled"),
          permanent: true
        });
      } else if (this.state.bidSuccess && this.props.auction.status === _configurations.AE_AUCTION_STATUS.BIDDING) {
        var registeredBid = (0, _currency.formatMoney)(this.state.bidAmount, this.props.auction.currency.iso.code);

        bidding = _react2.default.createElement(_FeedbackAlert2.default, {
          success: this.props.auction.bidMode === _configurations.AE_AUCTION_BID_MODE.SILENT ? __("auction::lot.bidRegistered", { amount: registeredBid }) : (0, _tempura.noMultiSpaceAfterLineFeed)(_templateObject, __("auction::lot.bidRegistered", { amount: registeredBid }), " ", __("auction::lot.youHaveLeadingBid")),
          permanent: true
        });
      } else if (this.props.auction.status === _configurations.AE_AUCTION_STATUS.BIDDING) {
        var maximumBidInformation = this.state.userMaximumBid > 0 ? _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "strong",
            null,
            __("auction::lot.youHaveMaximum") + ": "
          ),
          (0, _currency.formatMoney)(this.state.userMaximumBid, this.props.auction.currency.iso.code),
          _react2.default.createElement("br", null)
        ) : _react2.default.createElement(
          "div",
          null,
          __("auction::lot.noMaximumSet")
        );

        var submittedBidInformation = this.props.user.lastBid > 0 ? _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "strong",
            null,
            __("auction::lot.youHaveBidded") + ": "
          ),
          (0, _currency.formatMoney)(this.props.user.lastBid, this.props.auction.currency.iso.code),
          _react2.default.createElement("br", null)
        ) : _react2.default.createElement(
          "div",
          null,
          __("auction::lot.notBidded")
        );

        var minimumBid = this.props.lot.minimumBid;
        if (this.props.auction.bidMode === _configurations.AE_AUCTION_BID_MODE.SILENT) {
          minimumBid = this.nextBid(this.props.user.lastBid);
        } else if (this.props.auction.bidMode === _configurations.AE_AUCTION_BID_MODE.STANDARD && this.state.userMaximumBid > 0) {
          minimumBid = this.nextBid(Math.max(this.state.userMaximumBid, this.state.leadingBid));
        }

        var bidForm = _react2.default.createElement(
          _Form2.default,
          {
            role: "form",
            inline: true,
            onSubmit: this.handleMakeBid
          },
          _react2.default.createElement(
            "div",
            { style: { marginBottom: 10 } },
            _react2.default.createElement(
              _ButtonGroup2.default,
              { bsSize: "xsmall" },
              _react2.default.createElement(
                _Button2.default,
                {
                  active: !this.state.isMaximumBidding,
                  bsStyle: !this.state.isMaximumBidding ? "success" : undefined,
                  disabled: this.state.hasLeadingBid,
                  onClick: this.handleToggleMaximumBid
                },
                __("auction::lot.standardBid")
              ),
              _react2.default.createElement(
                _Button2.default,
                {
                  active: this.state.isMaximumBidding,
                  bsStyle: this.state.isMaximumBidding ? "success" : undefined,
                  onClick: this.handleToggleMaximumBid
                },
                __("auction::lot.maximumBid")
              )
            )
          ),
          _react2.default.createElement(_Combobox2.default, {
            data: this.state.bidSuggestions,
            placeholder: this.state.isMaximumBidding ? __("auction::lot.maximumBidAmount") : __("auction::lot.bidAmount"),
            style: { display: "inline-block" },
            textField: "text",
            value: this.state.bidAmount,
            valueField: "value",
            onChange: this.handleBidAmountChange
          }),
          " ",
          _react2.default.createElement(
            _Button2.default,
            {
              bsStyle: "success",
              type: "submit"
            },
            __("auction::lot.bid")
          ),
          _react2.default.createElement(
            _HelpBlock2.default,
            null,
            "(",
            __("auction::lot.enterOrMore", {
              amount: (0, _currency.formatMoney)(minimumBid, this.props.auction.currency.iso.code)
            }),
            ")"
          ),
          maximumBidInformation || submittedBidInformation || null
        );

        bidding = _react2.default.createElement(
          "div",
          null,
          bidInformation,
          _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
              _Col2.default,
              { md: 4 },
              _react2.default.createElement(
                "strong",
                null,
                this.state.isMaximumBidding ? __("auction::lot.makeMaximumBid") : __("auction::lot.makeBid")
              )
            ),
            _react2.default.createElement(
              _Col2.default,
              { md: 8 },
              bidForm
            )
          )
        );
      }

      return _react2.default.createElement(
        _Panel2.default,
        {
          header: _react2.default.createElement(
            "h3",
            null,
            __("auction::lot.bidding"),
            " ",
            _react2.default.createElement(
              "small",
              null,
              bidMode
            )
          )
        },
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _Col2.default,
            { md: 12 },
            _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(_FeedbackAlert2.default, {
                errors: this.state.bidErrors,
                info: this.state.hasLeadingBid ? __("auction::lot.nowLeadingBid") : null,
                warning: this.props.user.overbidded ? __("auction::lot.overBidded") : null,
                permanent: true
              })
            )
          )
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _Col2.default,
            { md: 4 },
            _react2.default.createElement(
              "strong",
              null,
              __("auction::lot.endTime"),
              ": "
            )
          ),
          _react2.default.createElement(
            _Col2.default,
            { md: 8 },
            _react2.default.createElement(
              "p",
              null,
              (0, _datetime.localizeDate)({ date: this.props.auction.bidEndDate }).date,
              _react2.default.createElement("br", null),
              _react2.default.createElement(
                "small",
                null,
                "(",
                _react2.default.createElement(
                  _TimeDifference2.default,
                  { targetDate: this.props.auction.bidEndDate },
                  _react2.default.createElement(
                    _TimeDifference2.default.Before,
                    null,
                    _react2.default.createElement(_TimeDifference2.default.Display, { noWords: true }),
                    " ",
                    __("general::left")
                  ),
                  _react2.default.createElement(
                    _TimeDifference2.default.After,
                    null,
                    _react2.default.createElement(_TimeDifference2.default.Display, null)
                  )
                ),
                ")"
              )
            )
          )
        ),
        bidding,
        this.props.auction.bidMode === _configurations.AE_AUCTION_BID_MODE.STANDARD ? _react2.default.createElement(
          _Panel2.default,
          {
            bsStyle: "success",
            header: __("lot::bidHistory"),
            style: { marginTop: 10 },
            collapsible: true
          },
          _react2.default.createElement(
            _Table2.default,
            { fill: true, striped: true },
            _react2.default.createElement(
              "thead",
              null,
              _react2.default.createElement(
                "tr",
                null,
                _react2.default.createElement(
                  "th",
                  null,
                  __("general::date")
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  __("general::bidder")
                ),
                _react2.default.createElement(
                  "th",
                  null,
                  __("general::amount")
                )
              )
            ),
            _react2.default.createElement(
              "tbody",
              null,
              this.props.lot.bids.map(function (_ref2, index) {
                var amount = _ref2.amount,
                    byCurrentUser = _ref2.byCurrentUser,
                    date = _ref2.date,
                    user = _ref2.user;
                return _react2.default.createElement(
                  "tr",
                  {
                    className: byCurrentUser ? "info" : undefined,
                    key: index
                  },
                  _react2.default.createElement(
                    "td",
                    null,
                    (0, _moment2.default)(date).fromNow()
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    _react2.default.createElement(
                      "span",
                      { style: { color: colorHash.hex(user) } },
                      __("general::buyer"),
                      " ",
                      _react2.default.createElement(
                        "strong",
                        null,
                        __("general::numberShort"),
                        user
                      )
                    ),
                    byCurrentUser ? _react2.default.createElement(
                      "small",
                      { className: "text-italic" },
                      " (" + __("general::you") + ")"
                    ) : null
                  ),
                  _react2.default.createElement(
                    "td",
                    null,
                    (0, _currency.formatMoney)(amount, _this2.props.auction.currency.iso.code)
                  )
                );
              }).reverse()
            )
          )
        ) : null
      );
    }
  }]);
  return AbsenteeBidModule;
}(_react.Component), _class.propTypes = {
  // Actions
  actions: _propTypes2.default.object.isRequired,

  // Auction information
  auction: _propTypes2.default.shape({
    // Date that bidding ends.
    bidEndDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]).isRequired,

    // Bid mode of the auction.
    bidMode: _propTypes2.default.oneOf(_configurations.AE_AUCTION_BID_MODE.getValues()).isRequired,

    // Date that bidding starts.
    bidStartDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]).isRequired,

    // Currency information for that auction.
    currency: _propTypes2.default.shape({
      // ISO 4247 information.
      iso: _propTypes2.default.shape({
        code: _propTypes2.default.string.isRequired
      }).isRequired,

      // Major and minor units of the currency with their symbols.
      units: _propTypes2.default.shape({
        major: _propTypes2.default.shape({
          symbol: _propTypes2.default.string.isRequired
        }),
        minor: _propTypes2.default.shape({
          symbol: _propTypes2.default.string.isRequired
        })
      }).isRequired
    }),

    // Different levels of increments.
    increments: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      jump: _propTypes2.default.number.isRequired,
      start: _propTypes2.default.number.isRequired
    }).isRequired).isRequired,

    // Status of the auction.
    status: _propTypes2.default.oneOf(_configurations.AE_AUCTION_STATUS.getValues()).isRequired
  }).isRequired,

  lot: _propTypes2.default.shape({
    // Number of bids on that lot.
    bidCount: _propTypes2.default.number.isRequired,

    // ID of the current lot.
    id: _propTypes2.default.string.isRequired,

    // Leading bid information.
    leadingBid: _propTypes2.default.shape({
      // Amount of the leading bid.
      amount: _propTypes2.default.number.isRequired,

      // Whether the current user is the leader.
      byCurrentUser: _propTypes2.default.string.isRequired,

      // Id of the leading bid.
      id: _propTypes2.default.string.isRequired
    }),

    // Minimum bid on that lot.
    minimumBid: _propTypes2.default.number.isRequired,

    // Starting bid on that lot.
    startingBid: _propTypes2.default.number.isRequired,

    // Status of the auction.
    status: _propTypes2.default.oneOf(_configurations.AE_LOT_STATUS.getValues()).isRequired
  }).isRequired,

  user: _propTypes2.default.shape({
    // User Id if he's logged in.
    id: _propTypes2.default.string,

    // Last bid amount of the user
    lastBid: _propTypes2.default.number,

    // Maximum bid amount of logged in user.
    maximumBid: _propTypes2.default.number,

    // Are we currently overbidded?
    overbidded: _propTypes2.default.bool.isRequired
  }).isRequired
}, _class.contextTypes = {
  // Translation utility.
  __: _propTypes2.default.func.isRequired
}, _temp2);
exports.default = AbsenteeBidModule;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/react-components/AbsenteeBidModule.jsx
// module id = 841
// module chunks = 15